// src/pages/TradeTracker/components/TradeRowDetails.jsx
import React from 'react';
import { openDoc } from 'lib/docs';
import { getTradeDetailSections } from './utils/tradeDetails';

function DetailSection({ section }) {
  const fields = section.fields.filter((field) => section.showMissing || field.value != null);
  if (!fields.length) return null;

  return (
    <div className="bg-app text-app rounded border p-3">
      <div className="text-sm font-semibold mb-2">{section.title}</div>
      <div
        className={
          section.columns === 5
            ? 'grid grid-cols-2 sm:grid-cols-5 gap-3 text-sm'
            : 'grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm'
        }
      >
        {fields.map((field) => (
          <div key={field.label}>
            <div className="text-xs text-muted-foreground">{field.label}</div>
            {field.value ?? '—'}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function TradeRowDetails({ t, v, selectedDate }) {
  // Flatten docs: each record_doc_scopes row contains a record_docs object
  const allDocs = (t.record_doc_scopes || [])
    .map((s) => s.record_docs)
    .filter(Boolean);
  const detailSections = getTradeDetailSections(t, v, selectedDate);

  return (
    <tr className="border-t border-border">
      <td colSpan="9" className="bg-muted/40 p-4">
        <div className="max-w-5xl space-y-4">
          {detailSections.map((section) => (
            <DetailSection key={section.title} section={section} />
          ))}

          {/* --- Documents --- */}
          <div className="bg-app text-app rounded border p-3">
            <div className="text-sm font-semibold mb-2">Trade Documents</div>
            {allDocs.length === 0 ? (
              <div className="text-xs text-muted-foreground">No documents available</div>
            ) : (
              <ul className="space-y-1 text-sm">
                {allDocs.map((doc) => (
                  <li key={doc.id}>
                    {doc.title}{' '}
                    <button
                      onClick={() => openDoc(doc.file_path)}
                      className="text-blue-600 underline hover:opacity-80"
                    >
                      Open
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </td>
    </tr>
  );
}
